






import { Component, Vue } from "vue-property-decorator";

/**
 * Small loading indicator: a little truck that trundles in place with a faint exhaust puff.
 * Uses the blue public/transitweb-truck.ico.
 */
@Component
export default class TruckLoader extends Vue {}
